import Reflux from 'reflux';
import { actions } from 'actions';

var SupplierStore = Reflux.createStore({
  suppliers: [],

  init: function() {
    this.listenTo(actions.getSupplier, this.getSupplier);
    this.listenTo(actions.saveSupplier, this.saveSupplier);
    this.listenTo(actions.getSuppliers, this.getSuppliers);
  },

  getSupplier: function(supplierId) {
    fetch(`/rest/v2/supplier/${supplierId}?includeRelations=1`).then((response) => {
      return response.json();
    }).then(data => {
      this.trigger(data);
    });
  },

  saveSupplier: function(supplierId, fields) {
    fetch(`/rest/v1/supplier/${supplierId}`, {
      method: 'PUT',
      body: JSON.stringify(fields),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      this.getSupplier(supplierId);
    });
  },

  /**
   * Updated from ajax to fetch.
   * Untested change as there is a listener, 
   * But nothing is calling the event.
   */
  getSuppliers: function () {
    if (this.suppliers.length > 0) {
      this.trigger(this.suppliers);
      return;
    }
    fetch('/rest/v2/supplier').then((response) => {
      return response.json();
    }).then(data => {
      this.suppliers = data;
      this.trigger(data);
    });
  }
})

export { SupplierStore };
